/**
 * ULTRAS Fan Chart period filter (TODAY / THIS WEEK / THIS MONTH / ALL TIME).
 *
 * Fully client-side, real data, zero polling and zero page reload:
 * - Each product card in a period-sortable carousel
 *   (sections/ultras-carousel-chart.liquid, when "React to Today/Week/Month
 *   filter chips" is on) is rendered with real data-sold-today /
 *   data-sold-week / data-sold-month / data-sold-all_time attributes,
 *   sourced from the ultras.units_sold_today / units_sold_week /
 *   units_sold_month / total_sales product metafields.
 * - Those metafields are kept current by Shopify Flow (order-paid
 *   increments the relevant counters; scheduled Flows reset
 *   today/week/month at their real-world boundaries). This file does not
 *   fetch or poll anything — it only re-orders DOM nodes that are already
 *   on the page using numbers Shopify Flow already wrote.
 * - Clicking a period chip re-sorts every matching carousel instantly by
 *   that attribute, renumbers the rank badges, and rewrites each card's
 *   "X SOLD" text to reflect the selected period.
 */
(function () {
  'use strict';

  var PERIOD_LABELS = {
    today: 'SOLD TODAY',
    week: 'SOLD THIS WEEK',
    month: 'SOLD THIS MONTH',
    all_time: 'SOLD',
  };

  function getSoldCount(item, period) {
    var raw = item.getAttribute('data-sold-' + period);
    var num = parseInt(raw, 10);
    return isNaN(num) ? 0 : num;
  }

  function applyPeriodToCarousel(carousel, period) {
    var track = carousel.querySelector('[data-carousel-track]');
    if (!track) return;

    var items = Array.prototype.slice.call(track.querySelectorAll(':scope > .ultras-carousel__item'));
    if (items.length === 0) return;

    // Stable sort (Array#sort is stable in all evergreen browsers) so ties
    // keep their original relative order rather than jumping around.
    items.sort(function (a, b) {
      return getSoldCount(b, period) - getSoldCount(a, period);
    });

    items.forEach(function (item, index) {
      track.appendChild(item);

      var rankEl = item.querySelector('.ultras-product-card__rank');
      if (rankEl) {
        var rankNumber = index + 1;
        var padded = rankNumber < 10 ? '0' + rankNumber : String(rankNumber);
        rankEl.textContent = padded;
      }

      var soldEl = item.querySelector('.ultras-move--sold');
      if (soldEl) {
        var count = getSoldCount(item, period);
        var label = PERIOD_LABELS[period] || PERIOD_LABELS.all_time;
        soldEl.textContent = count + ' ' + label;
      }
    });

    // Reset scroll position so the new #1 is visible.
    track.scrollTo({ left: 0, behavior: 'auto' });
  }

  function applyPeriodEverywhere(period) {
    document.querySelectorAll('[data-period-sortable]').forEach(function (carousel) {
      applyPeriodToCarousel(carousel, period);
    });
  }

  function initGroup(group) {
    if (group.dataset.ultrasPeriodInit === 'true') return;
    group.dataset.ultrasPeriodInit = 'true';

    var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-period]'));

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var period = btn.getAttribute('data-period');

        buttons.forEach(function (other) {
          var isActive = other === btn;
          other.classList.toggle('ultras-filters__chip--active', isActive);
          other.setAttribute('aria-pressed', String(isActive));
        });

        applyPeriodEverywhere(period);
      });
    });
  }

  function initAll(root) {
    root.querySelectorAll('[data-period-filter-group]').forEach(initGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
